import { defineMessages } from 'react-intl';

/** The copy of the Fans screen (design presave-subscriptions c1 to c6). */
export const fansMessages = defineMessages({
  title: { id: 'app.sml.fans.title', defaultMessage: 'Fans' },
  intro: {
    id: 'app.sml.fans.intro',
    defaultMessage:
      'The fans who get every new release from you. Each release lands in their library on release day, with no new pre-save.',
  },

  periodLabel: { id: 'app.sml.fans.period.label', defaultMessage: 'Period' },
  periodDays: { id: 'app.sml.fans.period.days', defaultMessage: '{days}d' },
  periodYear: { id: 'app.sml.fans.period.year', defaultMessage: '1y' },
  periodLocked: { id: 'app.sml.fans.period.locked', defaultMessage: 'Your plan keeps {days} days of history.' },
  exportCsv: { id: 'app.sml.fans.export', defaultMessage: 'Download CSV' },

  totalLabel: { id: 'app.sml.fans.total.label', defaultMessage: 'Subscribers' },
  totalHint: { id: 'app.sml.fans.total.hint', defaultMessage: 'Fans who get every release' },
  newLabel: { id: 'app.sml.fans.new.label', defaultMessage: 'New in {days} days' },
  newLeft: { id: 'app.sml.fans.new.left', defaultMessage: '{count} left in the same days' },
  newClosed: { id: 'app.sml.fans.new.closed', defaultMessage: 'Sign-ups are closed on Free' },
  reauthLabel: { id: 'app.sml.fans.reauth.label', defaultMessage: 'Need to reconnect' },
  reauthHint: {
    id: 'app.sml.fans.reauth.hint',
    defaultMessage: 'Their service sign-in ended. They get the email until they reconnect; we ask them once a month.',
  },

  growthTitle: { id: 'app.sml.fans.growth.title', defaultMessage: 'Growth' },
  growthSubscribed: { id: 'app.sml.fans.growth.subscribed', defaultMessage: 'Subscribed' },
  growthUnsubscribed: { id: 'app.sml.fans.growth.unsubscribed', defaultMessage: 'Unsubscribed' },
  growthDay: {
    id: 'app.sml.fans.growth.day',
    defaultMessage: '{date}: {subscribed} subscribed, {unsubscribed} unsubscribed',
  },
  growthPeriod: {
    id: 'app.sml.fans.growth.period',
    defaultMessage: 'In {days} days: {subscribed} subscribed, {unsubscribed} unsubscribed',
  },

  splitTitle: { id: 'app.sml.fans.split.title', defaultMessage: 'Where they listen' },
  splitMeta: { id: 'app.sml.fans.split.meta', defaultMessage: '{count, plural, one {# fan} other {# fans}}' },
  splitEmailOnly: { id: 'app.sml.fans.split.emailOnly', defaultMessage: 'Email only' },
  splitNote: {
    id: 'app.sml.fans.split.note',
    defaultMessage:
      'Email only: fans who gave an email, and YouTube Music fans. They get the email on release day, with no library save.',
  },

  releasesTitle: { id: 'app.sml.fans.releases.title', defaultMessage: 'Releases sent to your fans' },
  releasesMeta: { id: 'app.sml.fans.releases.meta', defaultMessage: 'Newest first' },
  releasesNone: {
    id: 'app.sml.fans.releases.none',
    defaultMessage: 'No release went to your fans yet. Your next release goes to them on release day.',
  },
  colRelease: { id: 'app.sml.fans.releases.col.release', defaultMessage: 'Release' },
  colSaved: { id: 'app.sml.fans.releases.col.saved', defaultMessage: 'Saved' },
  colEmailed: { id: 'app.sml.fans.releases.col.emailed', defaultMessage: 'Emailed' },
  colNotSaved: { id: 'app.sml.fans.releases.col.notSaved', defaultMessage: 'Not saved' },
  sourceCampaign: { id: 'app.sml.fans.releases.source.campaign', defaultMessage: 'Pre-save' },
  sourceCatalog: { id: 'app.sml.fans.releases.source.catalog', defaultMessage: 'Catalog' },
  today: { id: 'app.sml.fans.releases.today', defaultMessage: 'Today' },
  savingNow: { id: 'app.sml.fans.releases.savingNow', defaultMessage: '{day} · saving now' },
  phoneCounts: {
    id: 'app.sml.fans.releases.phoneCounts',
    defaultMessage: '{saved} saved, {emailed} emailed',
  },
  reasonNoItem: { id: 'app.sml.fans.releases.reason.noItem', defaultMessage: '{count} not on their service' },
  reasonReauth: { id: 'app.sml.fans.releases.reason.reauth', defaultMessage: '{count} need to reconnect' },
  reasonCap: { id: 'app.sml.fans.releases.reason.cap', defaultMessage: '{count} weekly limit' },
  reasonPlan: { id: 'app.sml.fans.releases.reason.plan', defaultMessage: '{count} email only on Free' },
  reasonFailed: { id: 'app.sml.fans.releases.reason.failed', defaultMessage: '{count} failed' },
  loadMore: { id: 'app.sml.fans.releases.loadMore', defaultMessage: 'Load more' },

  emptyTitle: { id: 'app.sml.fans.empty.title', defaultMessage: 'No subscribers yet' },
  emptyText: {
    id: 'app.sml.fans.empty.text',
    defaultMessage:
      'Turn one pre-save into every release. Fans who subscribe get each new song in their library on release day, and you never ask twice.',
  },
  emptyWay: { id: 'app.sml.fans.empty.way', defaultMessage: 'Way {number}' },
  emptyWayPresaveTitle: { id: 'app.sml.fans.empty.wayPresave.title', defaultMessage: 'After a pre-save' },
  emptyWayPresaveText: {
    id: 'app.sml.fans.empty.wayPresave.text',
    defaultMessage: 'A fan who pre-saves gets one question: "Save every future release from you too?"',
  },
  emptyWayBlockTitle: { id: 'app.sml.fans.empty.wayBlock.title', defaultMessage: 'The Get every release block' },
  emptyWayBlockText: {
    id: 'app.sml.fans.empty.wayBlock.text',
    defaultMessage: 'Put it on any SmartLink, for example your link-in-bio page. One tap subscribes.',
  },
  emptyAddBlock: { id: 'app.sml.fans.empty.addBlock', defaultMessage: 'Add the Get every release block' },
  emptyCreatePresave: { id: 'app.sml.fans.empty.createPresave', defaultMessage: 'Create a pre-save' },

  lockTitle: {
    id: 'app.sml.fans.lock.title',
    defaultMessage:
      '{count, plural, one {Your # fan now gets an email, not the song} other {Your # fans now get an email, not the song}}',
  },
  lockText: {
    id: 'app.sml.fans.lock.text',
    defaultMessage:
      'On Free, new releases reach them by email only, and no new fan can subscribe. Upgrade, and each release goes straight into their library again.',
  },
  lockPlan: { id: 'app.sml.fans.lock.plan', defaultMessage: 'On {plan}, {price} a month' },
  lockPlanNoPrice: { id: 'app.sml.fans.lock.planNoPrice', defaultMessage: 'On the {plan} plan' },
  lockButton: { id: 'app.sml.fans.lock.button', defaultMessage: 'See plans' },
});
